<template>
  <div v-if="results.length" :class="$style['search-suggestions-result']">
    <h4 :class="$style['search-suggestions-result__title']">
      {{ title }}
    </h4>
    <List v-if="type !=='products'">
      <LazyCircleList :items="formatResults(results)" />
    </List>

    <div v-else>
      <ProductListItem
        v-for="(result, index) in results"
        :key="result.cId"
        :data-index="index"
        :highlight-text="searchTerm"
        :to="{
          name: `${$lang}-product-slug-id`,
          params: { id: result.cId, slug: result.slug }
        }"
        vertical
        :item="result" />
    </div>
  </div>
</template>
<script setup>
const config = useRuntimeConfig()
const { searchTerm } = storeToRefs(useSearchStore())
const { $lang } = useNuxtApp()

defineProps({
  type: {
    type: String,
    default: null
  },
  title: {
    type: String,
    default: null
  },
  results: {
    type: Object,
    default: null
  }
})

const formatResults = results => {
  return results.map(result => {
    let imageUrl = '/icon.png'
    const navigationImage = result.images?.find(image => image.type === 'navigation')
    const productImage = result.images?.find(image => image.type === 'product')
    if (productImage) {
      imageUrl = `${config.public.cdnURL}pictures/thumbs/${productImage.value}-thumbnail.webp`
    }
    if (navigationImage) {
      imageUrl = `${config.public.cdnURL}pictures/navigation/thumbs/${navigationImage.value}.webp `
    }

    return {
      title: result.title,
      slug: `/${$lang}/${result.slug}`,
      image: imageUrl
    }
  })
}
</script>
<style lang="scss" module>
.search-suggestions-result {
    display: flex;
    flex-direction: column;
    margin-bottom: calc(var(--spacing ) * 2);

    &__title {
      padding: var(--spacing) calc(var(--spacing ) * 2);
      font-family: var(--font-base);
      font-size: var(--font-size-s);
    }
}
</style>
